import React from 'react';
import * as styles from './Icons.scss';

import Icon from '../Icon';
import { openNewTab, openPassportPopup } from '../../utils';

const Icons = (props) => {
  const {
    stars,
    trafficLight,
    reputationSignal,
    countryRating,
    cityRating,
    realTrucker,
    orders,
    atiDocs,
    confirmedContacts,
    epdBadgeIcon,
    starsUrl,
    reputationUrl,
    realTruckerUrl,
    trafficLightUrl,
    topRatingUrl,
    atiDocsUrl,
    ordersUrl,
    confirmedContactsUrl,
    epdBadgeIconUrl,
  } = props;

  return (
    <div className={styles.icons}>
      <Icon
        icon={stars}
        url={starsUrl}
        onClick={e => openPassportPopup(e, starsUrl)}
        classname={styles.stars}
      />
      <Icon
        icon={trafficLight}
        url={trafficLightUrl}
        onClick={e => openPassportPopup(e, trafficLightUrl)}
        classname={styles.trafficlight}
      />
      <Icon
        icon={reputationSignal}
        url={reputationUrl}
        onClick={e => openPassportPopup(e, reputationUrl)}
        classname={styles.reputationSignal}
      />
      <Icon
        icon={countryRating}
        url={topRatingUrl}
        classname={styles.countryRating}
        complexTooltip
      />
      <Icon
        icon={cityRating}
        url={topRatingUrl}
        classname={styles.cityRating}
        complexTooltip
      />
      <Icon
        icon={realTrucker}
        url={realTruckerUrl}
        onClick={e => openPassportPopup(e, realTruckerUrl)}
        classname={styles.realTrucker}
      />
      <Icon
        icon={orders}
        url={ordersUrl}
        onClick={e => openPassportPopup(e, ordersUrl)}
        classname={styles.orders}
      />
      <Icon
        icon={atiDocs}
        url={atiDocsUrl}
        classname={styles.atiDocs}
      />
      <Icon
        icon={confirmedContacts}
        url={confirmedContactsUrl}
        onClick={e => openPassportPopup(e, confirmedContactsUrl)}
        classname={styles.confirmedContacts}
      />
      <Icon
        icon={epdBadgeIcon}
        url={epdBadgeIconUrl}
        onClick={() => openNewTab(epdBadgeIconUrl)}
        classname={styles.epdBadge}
      />
    </div>
  );
};

export default Icons;
